import { chains, } from "../chains";

import {
	hasTokenTraits,
	isTokenAddress,
	isTokenSymbol,
	type TokenIdentifier,
	type TokenDefinition,
	type ValidChainId,
} from "@bracket/types";

import {
	isAddress,
	isTokenDefinition,
} from "@bracket/chainography/types";


// ValidChainId until we are sure its gone
export const getTokenDefinition = ( token: TokenIdentifier, opts?: ValidChainId|{ exclude?: string[] }, ): TokenDefinition => {

	try {

		if(opts && typeof opts === "number") {
			return getTokenDefinitionDepricating(token, opts);
		}

		if(isTokenDefinition(token)) {
			return token;
		}

		if(hasTokenTraits(token)) {

			const { address, symbol, chainId, identifier, } = token;

			// an empty address assuems the native currency of the chain. temporary fix.
			if(address === "") {
				if(chainId === 1 || chainId === 42161) {
					return chains[chainId].tokens.ETH;
				}
				if(chainId === 200810 || chainId === 200901) {
					return chains[chainId].tokens.BTC;
				}
				throw new Error("token provided without a symbol or address");
			}

			if(isTokenAddress(address) || isTokenAddress(identifier)) {
				const addr = address || identifier;
				const definition = Object.values(chains[chainId].tokens).find(tk => {
					if(tk.address.toLowerCase() === addr.toLowerCase()) {
						if(opts && typeof opts === "object" && Array.isArray(opts.exclude)) {
							if(!opts.exclude.includes(tk.symbol)) {
								return tk;
							}
						}
						else {
							return tk;
						}
					}
				});
				if(isTokenDefinition(definition)) {
					return definition;
				}
				throw new Error(`existing but misconfigured token "${token}"`);
			}

			if(isTokenSymbol(symbol, chainId) || isTokenSymbol(identifier, chainId)) {
				const symb = symbol || identifier;
				return chains[chainId].tokens[symb];
			}

			throw new Error("token provided without a symbol or address");
		}

		console.log("HAS TOKEN TRAITS", hasTokenTraits(token), token);
		console.trace();
		throw new Error("argued token is invalid - neither a token definition nor a token traits object");
	}
	catch( err ) {

		throw new Error(`@bracket/chainography::getTokenDefinition has errored - ${err.message}`);
	}
}


export const getTokenDefinitionDepricating = ( token: TokenIdentifier | string, chainId: ValidChainId = 1 ): TokenDefinition => {
	console.warn(`getTokenDefinition is changing. detected a deprecated call - use getTokenDefinition with a token identifier object, not ${token} ${chainId}`);
	console.trace();
	try {
		if(chainId in chains) {
			if(isTokenDefinition(token)) {
				return token;
			}
			if(typeof token === "string") {
				if(token === "") {
					throw new Error("getTokenDefinition is being called with an emtpy token, assuming ETH which no longer exists...");
				}
				if(isAddress(token)) {
					const definition = Object.values(chains[chainId].tokens).find(tk => tk.address.toLowerCase() === token.toLowerCase());
					if(isTokenDefinition(definition)) {
						return definition;
					}
					throw new Error(`existing but misconfigured token "${token}"`);
				}
				if(isTokenSymbol(token, chainId)) {
					return chains[chainId].tokens[token];
				}
				throw new Error(`unknown token ${token} on chain ${chainId}`);
			}
			throw new Error("token provided without a symbol or address");
		}
		throw new Error(`invalid chain id ${chainId}`);
	}
	catch( err ) {
		throw new Error(`@bracket/chainography::getTokenDefinition has errored - ${err.message}`);
	}
}

